// M_Categories.jsx
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form';
import { FiAlertTriangle, FiSave, FiSlash } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { editCategories, newCategories } from '../../app/store/catalogs/thunk';
import { InputValidators } from '../../utils/InputValidators';
import { useDispatch } from 'react-redux';

export const M_Categories = ({ selectedItem, setSelectedItem, onClose }) => {
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
    const dispatch = useDispatch();

    // Cuando cambia selectedItem, actualizar los campos del formulario
    useEffect(() => {
        if (selectedItem) {
            setValue("nombreCategoria", selectedItem.NAMECATEGORY);
            setValue("descripcionCategoria", selectedItem.DESCRIPTIONS);
        } else {
            reset();
        }
    }, [selectedItem, setValue, reset]);

    const save = (data) => {
        // console.log("Datos guardados:", data);
        if (selectedItem) {
            Swal.fire({
                title: 'Atención',
                text: "Está por modficiar una Categoria, ¿Desea de continuar con esta acción?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3b7ddd',
                cancelButtonColor: '#dc3545',
                cancelButtonText: 'No',
                confirmButtonText: 'Si'
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(editCategories(data,selectedItem.ID));
                    onClose(); // cerrar modal al guardar
                    reset();
                }
            })
        }
        else {
            Swal.fire({
                title: 'Atención',
                text: "Está por registar una Nueva Categoria, ¿Desea de continuar con esta acción?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3b7ddd',
                cancelButtonColor: '#dc3545',
                cancelButtonText: 'No',
                confirmButtonText: 'Si'
            }).then((result) => {
                if (result.isConfirmed) {
                    // console.log(data);
                    dispatch(newCategories(data));
                    onClose(); // cerrar modal al guardar
                    reset();
                }
            })
        }


    };

    return (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content" style={{ backgroundColor: '#ffffff' }}>
                    <div className="modal-header">
                        <h5 className="modal-title fw-bold">
                            {selectedItem ? `Edición de categoria: ${selectedItem.NAMECATEGORY}` : "Nueva Categoria"}
                        </h5>
                        <button type="button" className="btn-close" onClick={() => { reset(); onClose(); }}></button>
                    </div>

                    <form onSubmit={handleSubmit(save)}>
                        <div className="modal-body">
                            {selectedItem && (
                                <div className="alert alert-warning">
                                    <strong>Atención:</strong> Está modificando la información de una categoría.
                                </div>
                            )}

                            <div className="mb-3">
                                <label className="form-label">Nombre:</label>
                                <input type="text" className="form-control" autoComplete='off' {...register("nombreCategoria", { required: 'Nombre de la categoria es requerido', minLength: { value: 2, message: 'Debe tener mínimo 2 caracteres' } })}
                                    onKeyDown={InputValidators.validateAlphanumeric} />
                                {errors.nombreCategoria && (
                                    <div className='text-danger fw-bold mt-1'>
                                        <FiAlertTriangle size="22" /> {errors.nombreCategoria.message}
                                    </div>
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Descripción:</label>
                                <textarea className="form-control" rows="5" {...register("descripcionCategoria", { required: 'La descripcion es requerida' })}
                                    onKeyDown={InputValidators.validateAlphanumeric}></textarea>
                                {errors.descripcionCategoria && (
                                    <div className='text-danger fw-bold mt-1'>
                                        <FiAlertTriangle size="16" /> {errors.descripcionCategoria.message}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-danger" onClick={() => { reset(); onClose(); }}>
                                <FiSlash size={16} /> Cancelar
                            </button>
                            <button type="submit" className="btn btn-outline-primary">
                                <FiSave size={16} /> Guardar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
